export interface User {
  id: number;
  email: string;
  username: string;
  full_name: string;
  role: UserRole;
  is_active: boolean;
  is_verified: boolean;
  created_at: string;
  updated_at?: string;
  specialization?: string;
  experience_years?: number;
  accuracy_rate?: number;
  turnaround_time_avg?: number;
}

export enum UserRole {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  PHARMACIST = 'PHARMACIST',
  PHARMACY_TECHNICIAN = 'PHARMACY_TECHNICIAN',
  TRANSCRIPTIONIST = 'TRANSCRIPTIONIST'
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface RegisterData {
  email: string;
  username: string;
  full_name: string;
  password: string;
  role: UserRole;
  specialization?: string;
  experience_years?: number;
}

export interface AuthResponse {
  access_token: string;
  token_type: string;
}
